import LegalPage, { LSection, LList } from "../../components/legal/LegalPage";
import { LEGAL_IDENTITY } from "../../lib/legal";

export default function Dpa() {
  return (
    <LegalPage
      title="Acuerdo de Encargo del Tratamiento"
      subtitle="Anexo de protección de datos para clientes de Asset Passport. Forma parte de los términos B2B cuando Asset Passport trata datos personales por cuenta de un cliente."
      testid="dpa-page"
    >
      <LSection n="1" title="Partes">
        <p>
          <span className="font-medium text-zinc-900">Responsable del tratamiento:</span> la
          organización cliente.
        </p>
        <p>
          <span className="font-medium text-zinc-900">Encargado del tratamiento:</span>{" "}
          {LEGAL_IDENTITY.ownerName}, que opera bajo el nombre comercial {LEGAL_IDENTITY.commercialName}.
        </p>
      </LSection>

      <LSection n="2" title="Objeto">
        <p>
          El tratamiento necesario para prestar Asset Passport y alojar y gestionar la información
          de máquinas controlada por el cliente.
        </p>
      </LSection>

      <LSection n="3" title="Duración">
        <p>
          Durante la vigencia del uso de Asset Passport por parte del cliente y cualquier tratamiento
          posterior legal o técnicamente necesario.
        </p>
      </LSection>

      <LSection n="4" title="Naturaleza y finalidad">
        <LList
          items={[
            "alojamiento",
            "almacenamiento",
            "organización",
            "recuperación",
            "visualización",
            "gestión de accesos",
            "soporte",
            "seguridad",
            "procesos de borrado y desactivación",
          ]}
        />
      </LSection>

      <LSection n="5" title="Categorías de interesados">
        <p>Potencialmente:</p>
        <LList
          items={[
            "empleados del cliente",
            "técnicos",
            "administradores",
            "usuarios",
            "contratistas",
            "contactos de proveedores o fabricantes",
            "otras personas cuyos datos el cliente incluya lícitamente",
          ]}
        />
      </LSection>

      <LSection n="6" title="Datos personales">
        <p>Potencialmente:</p>
        <LList
          items={[
            "nombres",
            "emails profesionales",
            "roles",
            "identificadores",
            "autoría de intervenciones",
            "notas técnicas que se refieran a personas",
            "fotografías",
            "documentos que contengan información personal",
            "información de seguridad y acceso",
            "otros datos personales aportados por el cliente",
          ]}
        />
        <p>
          El cliente debe evitar subir datos de categorías especiales que no sean necesarios.
        </p>
      </LSection>

      <LSection n="7" title="Instrucciones del cliente">
        <p>
          Asset Passport trata los datos por cuenta del cliente únicamente siguiendo sus
          instrucciones documentadas, salvo que la ley exija lo contrario. El uso del servicio y de
          sus funciones configuradas constituye instrucciones documentadas dentro del ámbito de este
          acuerdo.
        </p>
      </LSection>

      <LSection n="8" title="Confidencialidad">
        <p>
          Las personas autorizadas para tratar los datos están sujetas a las obligaciones de
          confidencialidad apropiadas.
        </p>
      </LSection>

      <LSection n="9" title="Seguridad">
        <p>
          Asset Passport mantendrá medidas técnicas y organizativas apropiadas considerando el
          riesgo. Entre las medidas actualmente aplicadas se encuentran:
        </p>
        <LList
          items={[
            "hash de contraseñas",
            "cookies de autenticación protegidas",
            "aislamiento entre organizaciones",
            "acceso basado en roles",
            "limitación de peticiones (rate limiting)",
            "registro de auditoría",
            "verificación en dos pasos opcional",
            "acceso protegido a los archivos",
          ]}
        />
      </LSection>

      <LSection n="10" title="Subencargados">
        <p>
          El cliente otorga autorización general para el uso de subencargados necesarios. Los
          proveedores de infraestructura y servicios actualmente relevantes pueden incluir:
        </p>
        <LList
          items={[
            "Emergent — alojamiento y servicios gestionados de la aplicación",
            "Google Cloud — infraestructura cloud subyacente",
            "Cloudflare — entrega de red y seguridad",
            "AWS CloudFront — entrega de determinados activos de la plataforma",
            "Resend — email transaccional",
          ]}
        />
        <p>
          Asset Passport notificará a los clientes los cambios materiales de subencargados cuando
          sea razonablemente exigible, permitiendo objeciones por motivos legítimos de protección de
          datos.
        </p>
      </LSection>

      <LSection n="11" title="Transferencias internacionales">
        <p>
          Algunos subencargados o infraestructuras pueden implicar tratamientos en Estados Unidos.
          Las transferencias se articularán mediante los mecanismos de transferencia lícitos
          aplicables según el proveedor y las circunstancias.
        </p>
      </LSection>

      <LSection n="12" title="Derechos de los interesados">
        <p>
          Asset Passport prestará asistencia razonable al cliente en las solicitudes de acceso,
          rectificación, supresión, limitación, portabilidad y oposición, teniendo en cuenta la
          naturaleza del tratamiento y la funcionalidad disponible.
        </p>
      </LSection>

      <LSection n="13" title="Incidentes de seguridad">
        <p>
          Asset Passport informará al cliente sin dilación indebida tras tener conocimiento de una
          brecha de seguridad de datos personales que afecte a los datos tratados por cuenta del
          cliente, facilitando la información relevante disponible necesaria para las obligaciones
          del cliente.
        </p>
      </LSection>

      <LSection n="14" title="Evaluaciones de impacto y autoridades">
        <p>
          Asset Passport prestará asistencia razonable en evaluaciones de impacto y consultas a
          autoridades de control cuando sean requeridas, teniendo en cuenta el tratamiento y la
          información disponible.
        </p>
      </LSection>

      <LSection n="15" title="Supresión y devolución">
        <p>
          A la terminación, y conforme a las instrucciones del cliente y a los requisitos legales,
          Asset Passport hará inaccesibles o eliminará los registros de la aplicación utilizando los
          mecanismos disponibles.
        </p>
        <p>
          Transparencia técnica: la API actual del proveedor de almacenamiento de objetos gestionado
          no expone funcionalidad de borrado físico verificado de objetos, por lo que la eliminación
          a nivel de aplicación hace los archivos inaccesibles sin que pueda garantizarse la
          destrucción física inmediata en el almacenamiento subyacente.
        </p>
      </LSection>

      <LSection n="16" title="Información y auditoría">
        <p>
          Asset Passport pondrá a disposición del cliente la información razonablemente necesaria
          para demostrar el cumplimiento de sus obligaciones como encargado y cooperará con
          auditorías razonables, con sujeción a confidencialidad, seguridad, proporcionalidad,
          preaviso razonable, no perturbación del servicio y protección de otros clientes.
        </p>
      </LSection>

      <LSection n="17" title="Obligaciones del cliente">
        <LList
          items={[
            "tratar los datos de forma lícita",
            "facilitar instrucciones válidas",
            "mantener un acceso de usuarios apropiado",
            "evitar datos personales innecesarios",
            "atender las solicitudes de los interesados como responsable",
            "cumplir las obligaciones de protección de datos aplicables",
          ]}
        />
      </LSection>
    </LegalPage>
  );
}
